<template>
  <v-container class="pt-0" style="background-color: white" fluid>
    <v-row no-gutters justify="center">
      <v-col md="6" justify="center" align="center">
        <span style="font-size: 30px; color: #616161">
          <v-icon large class="pr-1 pb-2">mdi-abacus</v-icon>
          Proyecciones</span>
      </v-col>
    </v-row>
    <v-card flat class="pt-3">
      <v-row justify="center">
        <v-col md="3" >
          <v-autocomplete v-model="filters.calendar" :items="calendars" @change="get_projections" item-text="name" :disabled="new_projection.show == true"
            item-value="id" return-object label="Calendarios" outlined dense hide-details></v-autocomplete>
        </v-col>
        <v-col md="3" >
          <v-autocomplete hide-details v-model="filters.period" :items="periods" @change="get_projections" item-text="name" item-value="id"
            return-object label="Periodo" outlined dense :disabled="new_projection.show == true"></v-autocomplete>
        </v-col>
        <v-col md="3" >
          <v-autocomplete v-model="filters.bussines_unit" :items="calendar_business" label="Unidad de negocio"
            item-text="description_long" item-value="id" dense color="cyanText" required
            prepend-inner-icon="corporate_fare" outlined return-object hide-details :disabled="new_projection.show == true"></v-autocomplete>
        </v-col>
        <v-col md="3" >
          <v-autocomplete v-model="filters.location" :items="locationsFrombusiness" color="cyanText" label="Location"
            prepend-inner-icon="my_location" outlined @change="get_projections" :disabled="new_projection.show == true" return-object required dense hide-details>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row >
        <v-col md="3" >
          <v-autocomplete v-model="filters.accountingType" :items="accountingTypes" item-text="name" item-value="id" 
            return-object label="Tipo de cuenta" outlined dense hide-details :disabled="new_projection.show == true"></v-autocomplete>
        </v-col>
        <v-col md="3" align="center">
        <v-autocomplete v-model="filters.account"
                    :items="accounts_computed" @change="find_projection()"
                    item-text="name" item-value="id" return-object label="Cuenta" outlined dense
                    hide-details></v-autocomplete>
                </v-col>
        <v-col md="3" align="center">
                  <v-autocomplete v-model="filters.category"
                    :items="categories" @change="find_projection()"
                    item-text="name" item-value="id" return-object label="Categoria" outlined dense
                    hide-details></v-autocomplete>
                </v-col>
        <v-col md="3" align="center">
                  <v-autocomplete v-model="filters.subcategory"
                    :items="subcategories" @change="find_projection()"
                    item-text="name" item-value="id" return-object label="Subcategoria" outlined dense
                    hide-details></v-autocomplete>
                </v-col>
      </v-row>
        <v-row justify="center" align="center" class="mb-1">
          <v-col  :md="new_projection.show?'6':'12'" >
            <v-btn v-if="hasFeature('SHOP-032')" color="success" block outlined @click="add()">
              <v-icon>{{ new_projection.show ? "save" : "add" }}</v-icon>
              {{ new_projection.show ? "Guardar" : "Agregar" }}</v-btn>
          </v-col>
          <v-col  md="6" v-if="new_projection.show">
            <v-btn color="error" block outlined @click="cancel_add()">
             Cancelar</v-btn>
          </v-col>
        </v-row>
        <v-card outlined class="pt-3"  v-show="new_projection.show">
          <v-card-text class="pa-0">
            <v-container fluid class="pa-2">
              <v-card color="#E0F2F1" flat>
                <v-row justify="center" align="center">
                <v-col md="3"  align="center">
                  <span class="projections">Objetivo</span>
                </v-col>
                <v-col md="3"  align="center">
                  <span class="projections">Alcanzado</span>
                </v-col>
                <v-col md="3"  align="center">
                  <span class="projections">Restante</span>
                </v-col>
                <v-col md="3"  align="center">
                  <span class="projections">%</span>
                </v-col>
              </v-row>
              <v-divider class="my-3"></v-divider>
                <v-row justify="center" align="center" class="mb-1">
                  <v-col md="3" align="center">
                    <v-text-field v-model="new_projection.amount" label="Proyeccion" type="number"
                      :min="parseFloat(new_projection.remaining_amount) * (-1)" dense hide-details outlined></v-text-field>
                  </v-col>
                  <v-col md="3" align="center">
                    <span class="projections">{{ currencyFormat(new_projection.reached) }}</span>
                  </v-col>
                  <v-col md="3" align="center">
                    <span class="projections">{{
                      currencyFormat(available_projection)
                    }}</span>
                  </v-col>
                  <v-col md="3" align="center" class="pa-0">
                    <span class="projections" :style="`color: ${get_decorate(new_projection).color}`">
                      <v-icon :color="get_decorate(new_projection).color">{{ get_decorate(new_projection).icon }}</v-icon>
                      {{
                        porcent_add
                      }}%</span>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card outlined class="mt-3">
        <v-data-table height="50vh" :headers="headers" :items="projections_filter"  item-key="projection_id"
           fixed-header :items-per-page="60" >
              <template v-slot:[`item.porcent`]="{ item }">
                <v-progress-circular :rotate="90" :size="40" :width="6" :value="progress(item).value"
                    :color="progress(item).color">
                    <span style="font-size: 10px;"> {{ progress(item).value }}%</span>                   
                  </v-progress-circular>
                </template> 
              </v-data-table>
      </v-card>
      </v-card>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    accounts: [],
    headers: [
      {
        text: "Tipo de cuenta",
        align: "start",
        value: "account_type",
      },  
      { text: "Cuenta", value: "chart_of_account" },
      { text: "Categoria", value: "category" },
      { text: "Subcategoria", value: "subcategory" },
      { text: "Objetivo", value: "amount_formated", align: "end" },
      { text: "Alcanzado", value: "reached_formated", align: "end" },
      { text: "Restante", value: "remaining_amount_formated", align: "end" },
      { text: "%", value: "porcent",align: "center" },

    ],
    accountingTypes: [],
    filters: {
      bussines_unit: null,
      calendar: null,
      period:null,
      location: null,
      accountingType: null,
      account:null,
      category: null,
      subcategory: null,
    },
    new_projection: {
      show: false,
      account: null,
      amount: 0,
      last_amount: 0,
      reached: 0,
      remaining_amount: 0
    },
    accountingProjections: [],
    bussines_units: [],
    locations: [],
    calendars: [],
    all_categories:[],
    periods: [],
  }),
  mounted() {
    this.initialized();
  },
  computed: {
    accounts_computed(){
      let accounts = Object.assign([],this.accounts);
      if(this.filters.accountingType!=null &&this.filters.accountingType.id > 0) {
          accounts = accounts.filter((item) => item.account_type_id == this.filters.accountingType.id);
      }
      accounts.unshift({
        id: 0,
        name: "TODAS",
      })
      return accounts;
    },
    projections_filter() {
      if (this.filters.location == null || this.filters.accountingType == null) {
        return [];
      }      
      let pres = this.accountingProjections.filter((element) => element.location_id === this.filters.location.value);
      if(this.filters.accountingType.id){
        pres = pres.filter((element)=>element.account_type_id === this.filters.accountingType.id);
        this.headers[0].align=' d-none';
      }else{
        //this.filters.account.id = 0;
        this.headers[0].align='start';
      }
      if(this.filters.account==null){return pres}
      if(this.filters.account!= null && this.filters.account.id > 0){
        pres = pres.filter((element)=>element.chart_of_account_id === this.filters.account.id);
        this.headers[1].align=' d-none';
      }else{
        this.headers[1].align='start';
      }
      if(this.filters.category != null && this.filters.category.id > 0){
        pres = pres.filter((element)=>element.category_id === this.filters.category.id);
        this.headers[2].align=' d-none';
      }else{
        this.headers[2].align='start';
      }
      if(this.filters.subcategory != null && this.filters.subcategory.id > 0){
        pres = pres.filter((element)=>element.subcategory_id === this.filters.subcategory.id);
        this.headers[3].align=' d-none';
      }else{
        this.headers[3].align='start';
      }
      return pres;
    },
    calendar_business() {
      let business = [];
      if (
        this.filters.calendar == null ||
        this.filters.calendar.business_units.length == 0
      ) {
        return business;
      }
      for (let item of this.filters.calendar.business_units) {
        let bu = this.bussines_units.find(
          (element) => element.id === item.business_unit_id
        );
        if (bu) {
          business.push(bu);
        }
      }
      this.filters.bussines_unit = business[0];
      return business;
    },
    locationsFrombusiness() {
      if (this.filters.bussines_unit == null) {
        return [];
      }
      let data = this.locations.filter(
        (element) => element.bus_id == this.filters.bussines_unit.id
      );
      this.filters.location = data[0];
      return data;
    },
    porcent_add() {
      if (this.new_projection.last_amount == null || parseFloat(this.new_projection.last_amount) == 0) {
        return 0
      }
      const porcent = this.new_projection.amount * 100 / parseFloat(this.new_projection.last_amount);
      return porcent.toFixed(2);
    },
    available_projection() {
      let available = parseFloat(this.new_projection.amount) + parseFloat(this.new_projection.remaining_amount)
      if (this.new_projection.amount == '' || available < 0) {
        return 0;
      }
      return available;
    },
    categories(){
      let parents_categories = this.all_categories.filter((element)=>element.parent_id==null);
      parents_categories.unshift({
        id: 0,
        name: "TODAS",
      })
      return parents_categories;
    },
    subcategories(){
      if(this.filters.category == null) return []
      let sub_categories = this.all_categories.filter((element)=>element.parent_id==this.filters.category.id);
      sub_categories.unshift({
        id: 0,
        name: "TODAS",
      })
      return sub_categories
    }
  },
  watch: {
    "filters.category": function () {
      if(this.filters.category.id==0){
        this.filters.subcategory = this.categories[0];
      }
    }
   },
  methods: {
    async initialized() {
      //CALENDARIOS
      const calendars = await this.api_Get("accounting/get_calendars");
      this.calendars = await calendars.json();
      this.filters.calendar = this.calendars[0];
      //PERIODOS
      const periods = await this.api_Get("accounting/accounting_periods");
      this.periods = await periods.json();
      this.filters.period = this.periods[0];
      //UNIDADES DE NEGOCIOS
      this.bussines_units = await this.g_bussines();
      //LOCATIONS
      this.locations = await this.g_locations();
      //TIPOS DE CUENTAS
      const resultTypeAccountstypes = await this.api_Get("accounting/accounting_account");
      this.accountingTypes = await resultTypeAccountstypes.json();
      this.filters.accountingType = this.accountingTypes[4];
      this.accountingTypes.unshift({
        id: 0,
        name: "TODAS",
      })
      //CUENTAS
      const resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      let accounts=await resultTypeAccounts.json();
      accounts.forEach(element => {
        element.name=element.name+" (" +element.code+")"
        this.accounts.push({
          name: element.code+" - "+ element.name,
          id: element.id,
        
        })
      });
      this.filters.account = this.accounts_computed[0];
      //CATEGORIAS
      let resultTypeCategories = await this.api_Get("accounting/categories_diary_book");
      this.all_categories = await resultTypeCategories.json();
      this.filters.category = this.categories[0];
      this.filters.subcategory = this.subcategories[0];
      //PROYECCIONES
      this.get_projections();
    },
    add() {
      if (this.filters.account == null || this.filters.account.id == 0) {
        this.$toast.warning("Debe indicar la cuenta contable!");
        return;        
      }
      if (!this.new_projection.show) {
        this.find_projection();
        this.new_projection.show = true;
        return;
      }
      this.add_projection();
    },
    cancel_add(){
      this.new_projection.show = false;
      this.new_projection.is_edit = false;
      this.new_projection.reached = 0;
      this.new_projection.remaining_amount = 0;
    },
    async get_projections() {
          // Espera a que se complete el próximo ciclo de actualización del DOM
          await new Promise(resolve => this.$nextTick(resolve));

          let filter = { location_id: this.filters.location.value, accounting_calendar_id: this.filters.calendar.id, period_id: this.filters.period.id};

          const accountingProjections = await this.api_Post("accounting/accounting_projections",filter);
          this.accountingProjections = await accountingProjections.json();
          for (let key in this.accountingProjections) {
            this.accountingProjections[key].remaining_amount = parseFloat(this.accountingProjections[key].amount) - parseFloat(this.accountingProjections[key].reached);
            this.accountingProjections[key].remaining_amount_formated = this.currencyFormat(this.accountingProjections[key].remaining_amount);
            this.accountingProjections[key].amount_formated = this.currencyFormat(this.accountingProjections[key].amount);
            this.accountingProjections[key].reached_formated = this.currencyFormat(this.accountingProjections[key].reached);
          }
    },
    async add_projection() {
      if (this.new_projection.amount == 0) {
        this.$toast.warning("El monto no puede ser 0!");
        return;
      }
      if (((parseFloat(this.new_projection.last_amount)) + (parseFloat(this.new_projection.amount))) < 0) {
        this.$toast.warning("Monto no valido!");
        return;
      }
      try {
        const data = {
          projection_id: this.new_projection.projection_id,
          business_unit_id: this.filters.bussines_unit.id,
          location_id: this.filters.location.value,
          accounting_calendar_id: this.filters.calendar.id,
          accounting_period_id: this.filters.period.id,
          chart_of_account_id: this.filters.account.id,
          created_by: this.$store.state.auth.user.user.user_id,
          category_id: this.filters.category.id,
          subcategory_id: this.filters.subcategory.id,
          amount: this.new_projection.is_edit ? ((parseFloat(this.new_projection.last_amount)) + (parseFloat(this.new_projection.amount))) : this.new_projection.amount,
        };

        const accountingProjections = await this.api_Post("accounting/add_or_update_accounting_projections", data);
        if (accountingProjections.status != 200) {
          this.$toast.error("Error al intentar registrar la proyeccion!");
        } else {
          this.$toast.success("Proyeccion registrada correctamente!");
          this.get_projections();
          this.new_projection.account = null;
          this.new_projection.amount = 0;
        }
      } catch (error) {
        console.error(error.message);
      }
      this.new_projection.show = false;
    },
    progress(projection) {
      let progres = {
        value:
          (
            (parseFloat(projection.reached) * 100) /
            parseFloat(projection.amount)
          ).toFixed(0),
        color: "success",
      };

      if (parseFloat(projection.amount) == 0) {
        progres.value = 0;
      }
      if (progres.value < 25) {
        progres.color = "error";
      } else if (progres.value >= 25 && progres.value < 50) {
        progres.color = "warning";
      }

      return progres;
    },
    find_projection() {
      if(this.filters.account==null || this.filters.account.id==0){return}
      let projection_to_find={
        account: this.filters.account.id,
        category: this.filters.category.id==0?null:this.filters.category.id,
        subcategory: this.filters.subcategory.id==0?null:this.filters.subcategory.id
      }
      let projection = this.accountingProjections.find((element) => element.accounting_period_id==this.filters.period.id && element.chart_of_account_id == projection_to_find.account && element.category_id == projection_to_find.category && element.subcategory_id == projection_to_find.subcategory);

      if (projection) {
        this.new_projection.is_edit = true;
        this.new_projection.projection_id = projection.projection_id;
        this.new_projection.reached = projection.reached;
        this.new_projection.remaining_amount = parseFloat(projection.remaining_amount);
        this.new_projection.last_amount = parseFloat(projection.amount);
        return
      }
      this.new_projection.projection_id = null;
      this.new_projection.is_edit = false;
      this.new_projection.reached = 0;
      this.new_projection.remaining_amount = 0;
    },
    get_decorate(proyection) {
      if (parseFloat(proyection.amount) < 0) {
        return {
          color: '#E53935',
          icon: 'arrow_downward'
        }
      }
      return {
        color: '#00897B',
        icon: 'arrow_upward'
      }
    }
  },
};
</script>
<style scoped>
.projections {
  font-size: 18px;
  color: #0f0e0e;
}
</style>